<template>
  <div class="new-detail">
    <header class="page-header">
      <van-icon name="arrow-left" @click="$router.go(-1)" />
      <span>{{ $t('邀请好友') }}</span>
      <span></span>
    </header>
    <div class="article" :style="{ backgroundImage: `url(${imgPicUrl})` }">
      <div class="img">
        <vue-qr :text="inviteCode" :size="200"></vue-qr>
      </div>
      <div class="title">{{ $t('邀请好友发货，一起获取优惠券吧') }}</div>
      <div class="desc">{{ desc }}</div>
    </div>
  </div>
</template>
<script>
// import { getNotifyInfo } from '@/api/website.js';
// import { BASE_ROOT_URL } from '@/api/index.js';
// import { formatDate } from '@/utils/index.js';
import imgPic from '@/assets/images/invite.jpg';
import VueQr from 'vue-qr';
// function getValidTime(value) {
//   if (value == null || value == '') return '';
//   var myDate = new Date(value.match(/\d+/)[0] * 1);
//   return formatDate(myDate);
// }
export default {
  components: {
    VueQr,
  },
  data() {
    return {
      title: '',
      author: '',
      time: '',
      desc: '',
      img: '',
      content: '',
      imgPicUrl: imgPic,
      inviteCode: '',
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
  },
  mounted() {
    let h = window.innerHeight - 64;
    document.querySelector('.article').style.height = h + 'px';
    this.loadData();
  },
  methods: {
    htmlDecode(text) {
      //1.首先动态创建一个容器标签元素，如DIV
      var temp = document.createElement('div');
      //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
      temp.innerHTML = text;
      //3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
      var output = temp.innerText || temp.textContent;
      temp = null;
      //console.log(output);
      return output;
    },
    loadData() {
      if (this.$store.getters.userInfo != null) {
        var protocol = window.location.protocol;
        var domain = window.location.host;
        this.inviteCode =
          `${protocol}//${domain}/signup?inviteCode=` +
          this.$store.getters.userInfo.invitecode;
      } else {
        this.$toast.loading();
        const shouldLogin = confirm('您需要登录才能继续，是否前往登录页面？');
        if (shouldLogin) {
          this.$router.push({ path: '/login' });
        }
        // this.$store.dispatch('getUserInfo');
        // location.reload();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/_var';
.article {
  margin-top: rem(70px);
  background: #f84943;
  background-size: contain;
  background-repeat: no-repeat;
  max-width: 100%;
  padding: rem(20px);
  .title {
    font-size: rem(40px);
    text-align: center;
    color: #fff;
    padding: rem(15px);
  }
  .img {
    padding-top: 570px;
    width: 100%;
    text-align: center;
  }
  .img img {
    width: 100%;
    border: 1px solid #efefef;
    border-radius: 10px;
    width: 125px;
    height: 105px;
    display: block;
    margin: 0 auto;
    margin-bottom: 10%;
  }
  .content img {
    max-width: 100%;
  }
  .author {
    font-size: rem(18px);
    padding: rem(15px);
  }
}
</style>
